import type { CoverImage } from "$lib/features/image/imageDetails.type";

export function getUniqueImages(images: CoverImage[]): CoverImage[] {
    const uniqueImages = new Map(images.map((img) => [img.filename, img]));
    return Array.from(uniqueImages.values()).slice(0, 4);
}